import { IReactiveModel, ViewModel } from '@descomplica/microfrontend-core';
import { IsEmail, IsOptional, IsPhoneNumber } from 'class-validator';
import { action, makeAutoObservable, observable } from 'mobx';
import { toast } from 'react-toastify';
import { inject } from 'tsyringe';

import type { IPegasusIOGateway } from '@/shared/application/interfaces/pegasus-io.gateway';
import { IsFullname, ObservableForm } from '@/shared/presentation/forms/BaseForm';

class PersonalDataForm {
  @IsFullname({ message: 'Nome inválido' })
  name = '';

  @IsEmail({}, { message: 'E-mail inválido' })
  email = '';

  @IsPhoneNumber('BR', { message: 'Telefone inválido' })
  @IsOptional()
  phone = '';
}

@ViewModel()
export class BasicInfoViewModel implements IReactiveModel {
  @observable form = new ObservableForm(PersonalDataForm);
  @observable isSubmitting = false;
  @observable isLoading = true;
  @observable hasError = false;

  constructor(@inject('IPegasusIOGateway') private pegasusIOGateway: IPegasusIOGateway) {
    makeAutoObservable(this);
  }

  @action
  async onInit() {
    try {
      const { data: account } = await this.pegasusIOGateway.getAccount();

      this.form.setValue('name', account.name ?? '');
      this.form.setValue('email', account.email ?? '');
      this.form.setValue('phone', account.phone ?? '');
    } catch (error) {
      console.error(error);
      this.hasError = true;
    } finally {
      this.isLoading = false;
    }
  }

  async update() {
    try {
      if (this.form.hasError) {
        return;
      }

      this.isSubmitting = true;

      await this.pegasusIOGateway.updateBasicInfo({
        name: this.form.values.name,
        phone: this.form.values.phone,
      });

      toast.success('Dados atualizados com sucesso!');
    } catch (error) {
      console.error(error);
      toast.error('Erro ao atualizar os dados');
    } finally {
      this.isSubmitting = false;
    }
  }
}
